"use client";

import { createAuthClient } from "better-auth/react";

export const authClient = createAuthClient({
  fetchOptions: {
    credentials: "include",
  },
  sessionOptions: {
    refetchInterval: 300,
    refetchOnWindowFocus: true,
  },
});

export const { useSession, signIn, signOut, signUp } = authClient;

export type AuthClient = typeof authClient;
